import { Injectable, Injector } from '@angular/core';

import { SummaryService } from './summary.service';
import { BaseReportService } from './reportBase.service';
import type { IGetReportData, TSummaryTicketDailyValues } from '@shared/models';
import { Constants } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

@Injectable({
    'providedIn': 'root'
})
export class ReportTicketSummaryService extends BaseReportService implements IGetReportData {
    private summaryService: SummaryService;

    constructor(injector: Injector) {
        super(injector);
        this.summaryService = injector.get(SummaryService);
    }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];
        let reportColValues: string[];
        let rowInfo: any;
        let totalTickets = 0;
        let dailyValues: TSummaryTicketDailyValues[] = [];

        // Get the daily values from the summary service.
        try {
            const startingDate = this.options.startingDate;
            const endingDate = this.options.endingDate;
            const obj: any = await this.summaryService.getTicketsByDateRange(startingDate!, endingDate!);

            dailyValues = obj.dailyValues as TSummaryTicketDailyValues[];
        } catch (error) {
            throw new Error('Error in ReportTicketSummaryService. Unable to get daily values: ' + error);
        }
        
        // Process the daily values to build the report rows.
        try {
            for (const daily of dailyValues) {
                const numTickets = daily.count;
                const serviceAdvisor = daily.metadata.serviceAdvisor;
                // daily.date is already Timestamp
                // const isoString = this.dateService.formatTimestamp(daily.date, 'iso');
                // const timestamp = this.dateService.parse(isoString, DateTimeFormats.ShortDate);
                // const timestamp = this.dateService.formatTimestamp(daily.date, DateTimeFormats.ShortDate);
                // const date = this.formatDateTime(timestamp, DateTimeFormats.MediumDate);
                const date = this.formatDateTime(daily.date);
    
                reportColValues = [date, numTickets.toString(), serviceAdvisor];
                rowInfo = this.buildRowInfo(reportColValues, 'data');
                allRows.push(rowInfo);
    
                totalTickets += numTickets;
            }
    
            // Now show a blank row.
            reportColValues = [' ', ' ', ' '];
            rowInfo = this.buildRowInfo(reportColValues, 'data');
            allRows.push(rowInfo);
    
            // Show the summary row.
            reportColValues = ['Summary:', 'Total Tickets: ' + totalTickets.toString(), ' '];
            rowInfo = this.buildRowInfo(reportColValues, 'summary');
            allRows.push(rowInfo);
    
            // End of report data.
            allRows.push(undefined);
            const reportData = { 'data': allRows };
            return reportData;
        } catch (error) {
            throw new Error('Error in ReportTicketSummaryService. Unable to build the report: ' + error);
        }
        

        /*
        const allRows: any[] = [];
        let reportColValues: string[];
        let rowInfo: any;
        const startingDate = this.options.startingDate;
        const endingDate = this.options.endingDate;
        let totalTickets = 0;

        // const startingDate = this.options.startingDate;
        // const endingDate = this.options.endingDate;
        // const allRows: any[] = [];

        let serviceAdvisorsTickets: TTicket[];
        let allTickets: TTicket[] = [];

        const trips: TTrip[] = await this.tripsService.getByDateRange(startingDate, endingDate);
        trips.forEach((trip) => {
            const tickets = trip.tickets;

            // Select only those tickets that service advisors created and ignore all others.
            // The return to dealership ticket wasn't created by the service advisors but by the system.
            serviceAdvisorsTickets = tickets.filter(ticket => {
                return ticket.serviceAdvisor !== undefined;
            });

            serviceAdvisorsTickets.forEach(ticket => {
                allTickets.push(ticket);
            });

            // To determine the number of tickets each service advisors created on any given day,
            // create a combined key of the date and the service advisors.

            // Calculate data rows here.
            let keys = Object.keys(groups);
            keys.forEach((key) => {
                const arr = key.split('.');
                const keyCreatedDate = arr[0];
                const keyServiceAdvisorName = arr[1];

                const tixs = allTickets.filter(ticket => {
                    const dt = this.dateService.formatTimestamp(ticket.createdDate, DateTimeFormats.LongDate);
                    return(dt === keyCreatedDate && ticket.serviceAdvisor === keyServiceAdvisorName);
                });

                // const tixs = groups[key];
                const numTickets = tixs.length.toString();
                const reportColValues: string[] = [ keyCreatedDate, keyServiceAdvisorName, numTickets ];
                const rowInfo = this.buildRowInfo(reportColValues, 'data');
                allRows.push(rowInfo);
            });

            // For testing only!  Increase the number of data rows so that the
            // report will have numerours pages.  Makes it easier to test report.css.
            // if (this.sessionService.isDebugMode) {
            //     allRows = allRows.concat(allRows);
            //     allRows = allRows.concat(allRows);
            //     allRows = allRows.concat(allRows);
            //     allRows = allRows.concat(allRows);
            // }

            // Tack on the summary totals.
            const row = this.buildRowInfo(['Summary:', ' ', ' '], 'summary');
            allRows.push(row);
            // allRows.push(super.buildRowInfo(['Summary:', ' ', ' '], 'summary'));

            // Calculate summary totals rows here.
            keys = Object.keys(groups);
            keys.forEach((serviceAdvisorName) => {
                const tixs = groups[serviceAdvisorName];
                const numTickets = tixs.length.toString();
                const reportColValues: string[] = [ ' ', serviceAdvisorName, numTickets ];
                // const rowInfo = super.buildRowInfo(reportColValues, 'summary');
                const rowInfo = this.buildRowInfo(reportColValues, 'summary');
                allRows.push(rowInfo);
            });

            allRows.push(undefined);
            const reportData = {'data': allRows};
            return reportData;
        });
*/
    }
}
